// used in apps/backend-monitor/src/app/splash/setSplash.ts

// This is a good place to see what ll the front end endpoints are.
// There are also some backend on enpoints.
//

export enum FrontendEnum {
  'apps.orgbrain.ai' = 'apps.orgbrain.ai',
  'staging.orgbrain.ai' = 'staging.orgbrain.ai',
  'testing.prod.orgbrain.ai' = 'testing.prod.orgbrain.ai',
  'rollback-server.orgbrain.ai' = 'rollback-server.orgbrain.ai',
  'debug-prod.orgbrain.ai' = 'debug-prod.orgbrain.ai',
  'devel.staging.orgbrain.ai' = 'devel.staging.orgbrain.ai',
  'preprod.staging.orgbrain.ai' = 'preprod.staging.orgbrain.ai',
  'preprod2.orgbrain.ai' = 'preprod2.orgbrain.ai',
  'proto.orgbrain.ai' = 'proto.orgbrain.ai',
  'localhost' = 'localhost',
  'null' = 'null',
  'test.orgbrain.ai' = 'test.orgbrain.ai',
  'stable.orgbrain.ai' = 'stable.orgbrain.ai',
  'home.drpjl.com' = 'home.drpjl.com',
}

export const frontendNamesProd: FrontendEnum[] = [
  FrontendEnum['apps.orgbrain.ai'],
  FrontendEnum['staging.orgbrain.ai'],
  FrontendEnum['testing.prod.orgbrain.ai'],
  FrontendEnum['rollback-server.orgbrain.ai'],
  FrontendEnum['debug-prod.orgbrain.ai'],
  FrontendEnum['stable.orgbrain.ai'],
];

export const frontendNamesTest: FrontendEnum[] = [FrontendEnum['test.orgbrain.ai']];

export const frontendNamesStaging = [
  FrontendEnum['devel.staging.orgbrain.ai'],
  FrontendEnum['preprod2.orgbrain.ai'],
  FrontendEnum['preprod.staging.orgbrain.ai'],
  FrontendEnum['localhost'],
  FrontendEnum['home.drpjl.com'],
];

export const frontendNamesE2E = [FrontendEnum['localhost']];

// Enumerate the different servers for each configuration
export enum ServerUrlEnum {
  ADMIN = 'ADMIN',
  GRAPHQL = 'GRAPHQL',
  GRAPHQL_ENDPOINT = 'GRAPHQL_ENDPOINT',
  GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT = 'GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT',
  PDF = 'PDF',
  FILE = 'FILE',
  WEBPUSH = 'WEBPUSH',
  MAIN = 'MAIN',
  TAX = 'TAX',
  TRPC = 'TRPC',
}

// Enumerate the possible values for the server configurations

export enum ServerConfigEnum {
  PRODUCTION_A_SERVERS = 'PRODUCTION_A_SERVERS',
  PRODUCTION_B_SERVERS = 'PRODUCTION_B_SERVERS',
  PREPROD_SERVERS = 'PREPROD_SERVERS',
  PREPROD2_SERVERS = 'PREPROD2_SERVERS',
  DEVEL_SERVERS = 'DEVEL_SERVERS',
  DEBUG_SERVERS = 'DEBUG_SERVERS',
  TESTPROD_SERVERS = 'TESTPROD_SERVERS',
  ROLLBACK_SERVERS = 'ROLLBACK_SERVERS',
  LOCAL_SERVERS = 'LOCAL_SERVERS',
  LOCAL_SERVERS_B = 'LOCAL_SERVERS_B',
  NULL_SERVERS = 'NULL_SERVERS',
  DEVEL_PROTO_SERVERS = 'DEVEL_PROTO_SERVERS',
  TEST_SERVERS = 'TEST_SERVERS',
  LOCAL_PROD_MONITOR_SERVERS = 'LOCAL_PROD_MONITOR_SERVERS',
  E2E_SERVERS = 'E2E_SERVERS',
  STABLE_SERVERS = 'STABLE_SERVERS',
  DEVEL_ALB_SERVERS = 'DEVEL_ALB_SERVERS',
  PRODUCTION_ALB_SERVERS = 'PRODUCTION_ALB_SERVERS',
  PRODUCTION_PROTO_SERVERS = 'PRODUCTION_PROTO_SERVERS',
  PJL_SERVERS = 'PJL_SERVERS',
}

export const defaultUrlsForFrontEnd: { [key in FrontendEnum]: ServerConfigEnum } = {
  'apps.orgbrain.ai': ServerConfigEnum.PRODUCTION_A_SERVERS,
  'staging.orgbrain.ai': ServerConfigEnum.PRODUCTION_B_SERVERS,
  'testing.prod.orgbrain.ai': ServerConfigEnum.TESTPROD_SERVERS,
  'rollback-server.orgbrain.ai': ServerConfigEnum.ROLLBACK_SERVERS,
  'debug-prod.orgbrain.ai': ServerConfigEnum.DEBUG_SERVERS,
  'devel.staging.orgbrain.ai': ServerConfigEnum.DEVEL_SERVERS,
  'preprod.staging.orgbrain.ai': ServerConfigEnum.PREPROD_SERVERS,
  'preprod2.orgbrain.ai': ServerConfigEnum.PREPROD2_SERVERS,
  localhost: ServerConfigEnum.LOCAL_SERVERS,
  'proto.orgbrain.ai': ServerConfigEnum.PRODUCTION_A_SERVERS,
  null: ServerConfigEnum.NULL_SERVERS,
  'test.orgbrain.ai': ServerConfigEnum.TEST_SERVERS,
  'stable.orgbrain.ai': ServerConfigEnum.STABLE_SERVERS,
  'home.drpjl.com': ServerConfigEnum.PJL_SERVERS,
};

export const serverConfigsProd: ServerConfigEnum[] = [
  ServerConfigEnum.PRODUCTION_A_SERVERS,
  ServerConfigEnum.PRODUCTION_B_SERVERS,
  ServerConfigEnum.ROLLBACK_SERVERS,
  ServerConfigEnum.TESTPROD_SERVERS,
  ServerConfigEnum.DEBUG_SERVERS,
  ServerConfigEnum.STABLE_SERVERS,
  ServerConfigEnum.PRODUCTION_ALB_SERVERS,
  ServerConfigEnum.PRODUCTION_PROTO_SERVERS,
];

export const serverConfigsStaging: ServerConfigEnum[] = [
  ServerConfigEnum.PREPROD2_SERVERS,
  ServerConfigEnum.PREPROD_SERVERS,
  ServerConfigEnum.LOCAL_SERVERS,
  ServerConfigEnum.LOCAL_SERVERS_B,
  ServerConfigEnum.LOCAL_PROD_MONITOR_SERVERS,
  ServerConfigEnum.DEVEL_PROTO_SERVERS,
  ServerConfigEnum.DEVEL_ALB_SERVERS,
  ServerConfigEnum.PJL_SERVERS,
];

export const serverConfigsE2E: ServerConfigEnum[] = [ServerConfigEnum.E2E_SERVERS];

export type UrlMap = { [key in ServerUrlEnum]: string | null };

// Define the type of the map of server configurations for frontends.
//
export type ServerConfigUrlMaps = { [key in ServerConfigEnum]: UrlMap };

export const staticServers = {
  TAX: 'https://taxdata-server.orgbrain.ai/tax',
  TAX_B: 'https://taxdata-server-b.orgbrain.ai/tax',
  PRODUCTION_MAIN: 'https://prod-server.orgbrain.ai/admin',
  PREPROD_MAIN: 'https://preprod-server.orgbrain.ai/admin',
  PROTO_MAIN: 'https://proto.orgbrain.ai/admin',
  LOCAL_MAIN: 'http://localhost:3001', // Just use normal admin server so we don't have to run two servers
};

export const serverUrlConfigMaps: ServerConfigUrlMaps = {
  PRODUCTION_A_SERVERS: {
    ADMIN: 'https://production-admin.orgbrain.ai/admin',
    TRPC: 'wss://production-admin.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://production-graphql.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://production-graphql.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://production-graphql.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://production-pdf.orgbrain.ai/admin',
    FILE: 'https://production-admin.orgbrain.ai/admin',
    WEBPUSH: 'https://production-admin.orgbrain.ai/admin/web-push', // 'https://prod-server.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PRODUCTION_MAIN,
    TAX: staticServers.TAX_B,
  },

  TESTPROD_SERVERS: {
    ADMIN: 'https://test-prod.orgbrain.ai/admin',
    TRPC: 'wss://test-prod.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://test-prod.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://test-prod.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://test-prod.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://test-prod.orgbrain.ai/admin',
    FILE: 'https://test-prod.orgbrain.ai/admin',
    WEBPUSH: 'https://test-prod.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PRODUCTION_MAIN,
    TAX: staticServers.TAX_B,
  },
  PRODUCTION_B_SERVERS: {
    ADMIN: 'https://test-admin.orgbrain.ai/admin',
    TRPC: 'wss://test-admin.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://test-graphql.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://test-graphql.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://test-graphql.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://test-pdf.orgbrain.ai/admin',
    FILE: 'https://test-admin.orgbrain.ai/admin',
    WEBPUSH: 'https://test-admin.orgbrain.ai/admin/web-push', //     'https://test-admin.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PRODUCTION_MAIN,
    TAX: staticServers.TAX_B,
  },

  PRODUCTION_ALB_SERVERS: {
    ADMIN: 'https://admin-alb.orgbrain.ai',
    TRPC: 'wss://admin-alb.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://graphql-alb.orgbrain.ai',
    GRAPHQL_ENDPOINT: 'https://graphql-alb.orgbrain.ai/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://graphql-alb.orgbrain.ai/graphql',
    PDF: 'https://admin-heavy-alb.orgbrain.ai',
    FILE: 'https://admin-heavy-alb.orgbrain.ai',
    WEBPUSH: 'https://admin-alb.orgbrain.ai/web-push', //     'https://test-admin.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PRODUCTION_MAIN,
    TAX: staticServers.TAX_B,
  },

  PRODUCTION_PROTO_SERVERS: {
    ADMIN: 'https://prod-asg-proto.orgbrain.ai/admin',
    TRPC: 'wss://prod-asg-proto.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://prod-asg-proto.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://prod-asg-proto.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://prod-asg-proto.orgbrain.ai/graphql/graphql',
    PDF: 'https://prod-asg-proto.orgbrain.ai/admin-heavy',
    FILE: 'https://prod-asg-proto.orgbrain.ai/admin-heavy',
    WEBPUSH: 'https://prod-asg-proto.orgbrain.ai/web-push', //     'https://test-admin.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PRODUCTION_MAIN,
    TAX: staticServers.TAX_B,
  },

  // Use:

  ROLLBACK_SERVERS: {
    // DEPReCAtED ?
    ADMIN: 'https://rollback-server.orgbrain.ai/admin',
    TRPC: 'wss://rollback-server.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://rollback-server.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://rollback-server.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://rollback-server.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://rollback-server.orgbrain.ai/admin',
    FILE: 'https://rollback-server.orgbrain.ai/admin',
    WEBPUSH: 'https://rollback-server.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PRODUCTION_MAIN,
    TAX: staticServers.TAX_B,
  },

  DEBUG_SERVERS: {
    ADMIN: 'https://debug-prod.orgbrain.ai/admin-server',
    TRPC: 'wss://debug-prod.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://debug-prod.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://debug-prod.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://debug-prod.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://debug-prod.orgbrain.ai/admin-server',
    FILE: 'https://debug-prod.orgbrain.ai/admin-server',
    WEBPUSH: 'https://debug-prod.orgbrain.ai/admin-server/web-push',
    MAIN: staticServers.PRODUCTION_MAIN,
    TAX: staticServers.TAX_B,
  },

  DEVEL_PROTO_SERVERS: {
    ADMIN: 'https://devel-asg-proto.orgbrain.ai/admin',
    TRPC: 'wss://devel-asg-proto.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://devel-asg-proto.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://devel-asg-proto.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://devel-asg-proto.orgbrain.aiwsgraphql/graphql',
    PDF: 'https://devel-asg-proto.orgbrain.ai/admin',
    FILE: 'https://devel-asg-proto.orgbrain.ai/admin',
    WEBPUSH: 'https://devel-asg-proto.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PREPROD_MAIN,
    TAX: staticServers.TAX_B,
  },

  DEVEL_ALB_SERVERS: {
    ADMIN: 'https://devel-admin-alb.orgbrain.ai',
    TRPC: 'wss://devel-admin-alb.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://devel-graphql-alb.orgbrain.ai',
    GRAPHQL_ENDPOINT: 'https://devel-graphql-alb.orgbrain.ai/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://devel-graphql-alb.orgbrain.ai/graphql',
    PDF: 'https://devel-admin-heavy-alb.orgbrain.ai',
    FILE: 'https://devel-admin-heavy-alb.orgbrain.ai',
    WEBPUSH: 'https://devel-admin-alb.orgbrain.ai/web-push', //     'https://test-admin.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PREPROD_MAIN,
    TAX: staticServers.TAX_B,
  },

  PJL_SERVERS: {
    ADMIN: 'https://server.home.drpjl.com/admin',
    TRPC: 'wss://server.home.drpjl.com/admin/trpc-ws',
    GRAPHQL: 'https://server.home.drpjl.com/graphql',
    GRAPHQL_ENDPOINT: 'https://server.home.drpjl.com/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://server.home.drpjl.com/graphql/graphql',
    PDF: 'https://server.home.drpjl.com/admin',
    FILE: 'https://server.home.drpjl.com/admin',
    WEBPUSH: 'https://server.home.drpjl.com/admin/web-push', //     'https://test-admin.orgbrain.ai/admin/web-push',
    MAIN: 'https://server.home.drpjl.com/admin',
    TAX: staticServers.TAX_B,
  },

  // DEVEL_LOAD_BALANCED_SERVERS: {
  //   ADMIN: 'https://poc-admin.orgbrain.ai',
  //   TRPC: 'wss://poc-admin.orgbrain.ai/trpc-ws',
  //   GRAPHQL: 'https://poc-graphql.orgbrain.ai',
  //   GRAPHQL_ENDPOINT: 'https://poc-graphql.orgbrain.ai/graphql',
  //   GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss:/poc-graphql.orgbrain.ai/graphql',
  //   PDF: 'https://poc-admin.orgbrain.ai',
  //   FILE: 'https://poc-admin.orgbrain.ai',
  //   WEBPUSH: 'https://poc-admin.orgbrain.ai/web-push',
  //   MAIN: staticServers.PREPROD_MAIN,
  //   TAX: staticServers.TAX_B,
  // },

  PREPROD_SERVERS: {
    ADMIN: 'https://preprod-server.orgbrain.ai/admin',
    TRPC: 'wss://preprod-server.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://preprod-server.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://preprod-server.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://preprod-server.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://preprod-server.orgbrain.ai/admin',
    FILE: 'https://preprod-server.orgbrain.ai/admin',
    WEBPUSH: 'https://preprod-server.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PREPROD_MAIN,
    TAX: staticServers.TAX_B,
  },

  PREPROD2_SERVERS: {
    ADMIN: 'https://preprod2-server.orgbrain.ai/admin',
    TRPC: 'wss://preprod2-server.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://preprod2-server.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://preprod2-server.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://preprod2-server.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://preprod2-server.orgbrain.ai/admin',
    FILE: 'https://preprod2-server.orgbrain.ai/admin',
    WEBPUSH: 'https://preprod2-server.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PREPROD_MAIN,
    TAX: staticServers.TAX_B,
  },

  DEVEL_SERVERS: {
    // CURRENTLY BROKE I THINK
    ADMIN: 'https://devel-server.orgbrain.ai/admin',
    TRPC: 'wss://devel-server.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://devel-server.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://devel-server.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://devel-server.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://devel-server.orgbrain.ai/admin',
    FILE: 'https://devel-server.orgbrain.ai/admin',
    WEBPUSH: 'https://devel-server.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PREPROD_MAIN,
    TAX: staticServers.TAX_B,
  },

  LOCAL_SERVERS: {
    ADMIN: 'http://localhost:3001',
    TRPC: 'ws://localhost:3001/trpc-ws',
    GRAPHQL: 'http://localhost:3333',
    GRAPHQL_ENDPOINT: 'http://localhost:3333/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'ws://localhost:3333/graphql',
    PDF: 'http://localhost:3001',
    FILE: 'http://localhost:3001',
    WEBPUSH: 'http://localhost:3001/web-push',
    MAIN: 'http://localhost:3001',
    TAX: staticServers.TAX_B,
  },

  LOCAL_SERVERS_B: {
    // So I can test switch server logic locally.
    ADMIN: 'http://localhost:3001',
    TRPC: 'ws://localhost:3001/trpc-ws',
    GRAPHQL: 'http://localhost:3333',
    GRAPHQL_ENDPOINT: 'http://localhost:3334/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'ws://localhost:3334/graphql',
    PDF: 'http://localhost:3001',
    FILE: 'http://localhost:3001',
    WEBPUSH: 'http://localhost:3001/web-push',
    MAIN: 'http://localhost:3001',
    TAX: staticServers.TAX_B,
  },

  LOCAL_PROD_MONITOR_SERVERS: {
    ADMIN: 'http://localhost:3001',
    TRPC: 'ws://localhost:3001/trpc-ws',
    GRAPHQL: 'http://localhost:3333',
    GRAPHQL_ENDPOINT: 'http://localhost:3333/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'ws://localhost:3333/graphql',
    PDF: 'http://localhost:3001',
    FILE: 'http://localhost:3001',
    WEBPUSH: 'http://localhost:3001/web-push',
    MAIN: 'http://localhost:3001',
    TAX: staticServers.TAX_B,
  },

  NULL_SERVERS: {
    ADMIN: 'http://0.0.0.0',
    TRPC: 'ws://0.0.0.0/trpc-ws',
    GRAPHQL: 'http://0.0.0.0',
    GRAPHQL_ENDPOINT: 'http://0.0.0.0',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'ws://0.0.0.0',
    PDF: 'http://0.0.0.0',
    FILE: 'http://0.0.0.0',
    WEBPUSH: 'http://0.0.0.0',
    MAIN: 'http://localhost:3001',
    TAX: 'http://0.0.0.0',
  },
  [ServerConfigEnum.TEST_SERVERS]: {
    ADMIN: 'https://preprod2-server.orgbrain.ai/admin',
    TRPC: 'wss://preprod2-server.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://preprod2-server.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://preprod2-server.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://preprod2-server.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://preprod2-server.orgbrain.ai/admin',
    FILE: 'https://preprod2-server.orgbrain.ai/admin',
    WEBPUSH: 'https://preprod2-server.orgbrain.ai/admin/web-push',
    MAIN: 'https://preprod2-server.orgbrain.ai/admin',
    TAX: staticServers.TAX_B,
  },
  [ServerConfigEnum.E2E_SERVERS]: {
    ADMIN: 'http://localhost:3001',
    TRPC: 'ws://localhost:3001/trpc-ws',
    GRAPHQL: 'http://localhost:3333',
    GRAPHQL_ENDPOINT: 'http://localhost:3333/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'ws://localhost:3333/graphql',
    PDF: 'http://localhost:3001',
    FILE: 'http://localhost:3001',
    WEBPUSH: 'http://localhost:3001/web-push',
    MAIN: 'http://localhost:3001',
    TAX: 'http://tax-stub',
  },
  [ServerConfigEnum.STABLE_SERVERS]: {
    ADMIN: 'https://stable-server.orgbrain.ai/admin',
    TRPC: 'wss://stable-server.orgbrain.ai/trpc-ws',
    GRAPHQL: 'https://stable-server.orgbrain.ai/graphql',
    GRAPHQL_ENDPOINT: 'https://stable-server.orgbrain.ai/graphql/graphql',
    GRAPHQL_SUBSCRIPTIONS_WS_ENDPOINT: 'wss://stable-server.orgbrain.ai/wsgraphql/graphql',
    PDF: 'https://stable-server.orgbrain.ai/admin',
    FILE: 'https://stable-server.orgbrain.ai/admin',
    WEBPUSH: 'https://stable-server.orgbrain.ai/admin/web-push',
    MAIN: staticServers.PRODUCTION_MAIN,
    TAX: staticServers.TAX_B,
  },
};

export type ServerUrlsPayload = { [deploy: string]: ServerConfigEnum };

export type DeployInfo = {
  BUILD_TIMESTAMP: string;
  BUILD_BRANCH: string;
  BUILD_WHO: string;
  ORGBRAIN_VERSION: string;
  COMMIT: string;
  COMMIT_DATE: string;
  MESSAGE: string;
};

export enum AppKeyEnum {
  'orgbrain' = 'orgbrain',
  'backend-admin' = 'backend-admin',
  'backend-graphql' = 'backend-graphql',
}

export type VersionListItem = {
  hash: any;
  author: any;
  date: any;
  version: string;
  message: string;
};

export type DeployStructure = {
  data: { [key in AppKeyEnum]: DeployInfo[] };
  list: VersionListItem[];
};

export type VersionData = {
  list: VersionListItem[];
  versionsMap: any;
};

export type SplashSetPayload = {
  html: string;
  serverConfig: { frontend: string; servers: ServerConfigEnum };
  stamp: number;
};

export type SplashRecordServerConfigs = { [frontend: string]: ServerConfigEnum };

export type SplashRecord = {
  _id?: any;
  html: string;
  serverConfigs: SplashRecordServerConfigs;
  stamp: number;
};

// export const signicatRedirectUrls = [
//   'https://testing.prod.orgbrain.ai/auth/index.html',
//   'https://apps.orgbrain.ai/auth/index.html',
//   'https://devel.staging.orgbrain.ai/auth/index.html',
//   'https://d185tl9g87mzff.cloudfront.net/auth/',
//   'https://preprod.staging.orgbrain.ai/auth/index.html',
//   'https://d462kiu0a5p6i.cloudfront.net/auth/',
//   'http://localhost:4200/auth',
// ];
